export const WeeklyDTRReportModal: string = 'WeeklyDTRReportModal';
